angular.module('tgaAdmin')
  .factory('httpPendingRequestInterceptor', [
    '$q', 'httpPendingRequestService',
    function ($q, httpPendingRequestService) {
      return {
        request(config) {
          config = config || {};
          if (angular.isUndefined(config.timeout) && config.cancelOnRouteChange) {
            config.timeout = httpPendingRequestService.newTimeout();
          }
          return config;
        },

        responseError(response) {
          if (response.config.timeout && response.config.timeout.isGloballyCancelled) {
            return $q.defer().promise;
          }
          return $q.reject(response);
        },
      };
    },
  ]);

angular.module('tgaAdmin').config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('httpPendingRequestInterceptor');
}]);
